module.exports = __webpack_public_path__ + "img/mega.587f2980.svg";